<template>
  <div class="cmp-distribution-order-deilvery-address-summary">
    <div style="box-shadow: 0px 3px 20px #E1EADB;margin-top:10px">
      <div
        class="box-header"
        @mousedown="$emit('click')"
        style="background-color: var(--bc-note); margin-top: 10px; margin: 0px"
      >
        <div class="box-header--name">
          {{ $dft.capitalizeWords($t("notes")) }}
        </div>
        <div class="box-header--body"></div>
        <div class="box-header--options"></div>
      </div>
      <DBoxTextarea
        :id="'internal_notes'"
        :value="order && order.internal_notes"
        @blur="
          (e) => onUpdated({ name: 'internal_notes', value: e.target.value })
        "
      />
    </div>

    <!-- 
      <h4 v-if="order.email1">{{order.email1}}</h4> -->
  </div>
</template>

<script>
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";

export default {
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    DBoxTextarea,
  },

  data: function () {
    return {};
  },
  computed: {},
  methods: {
    onUpdated: function ({ name, value }) {
      console.log("name,value", { name, value });
      this.$emit("changed", { name, value });
    },

    onClickEditDiscount: function () {
      //console.log("document.getElementById('document')",document.getElementById('deliveryInfoDiscount'))
      document.getElementById("deliveryInfoDiscount").scrollIntoView({
        behavior: "smooth",
      });
    },
  },
};
</script>
<style lang="scss">
.cmp-distribution-order-invoice-contact-summary {
  p {
    margin-bottom: 0px;
  }

  .box-header {
    color: var(--text-accent);
    // background: white;
    z-index: 0;

    cursor: default;
    transition: 150ms ease-out;

    margin: -1px -1px 0px -1px;

    border-top: 1px solid transparent;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    border-bottom: 1px solid var(--text-accent);

    display: flex;

    justify-content: space-between;

    &--name {
      padding: 5px 10px;
    }

    .box-header--row {
      padding: 5px 10px;
    }

    &--body {
      flex: 1;
    }

    &--options {
      display: flex;

      svg {
        border-left: 1px solid var(--text-accent);
      }

      img {
        border-left: 1px solid var(--text-accent);
        width: 30px;
      }
    }

    &.selected {
      background-color: var(--bc-selected);
      border-top: 1px solid var(--text-accent);
      border-left: 1px solid var(--text-accent);
      border-right: 1px solid var(--text-accent);
    }

    &.gray {
      background-color: var(--sprt-75);
      border-top: 1px solid var(--sprt-75);
      border-bottom: 1px solid var(--sprt-75);
      border-left: 1px solid var(--sprt-75);
      border-right: 1px solid var(--sprt-75);
      color: white;
    }

    // .box-header--options {
    // }

    i.fas {
      font-size: 14px;
    }
  }
}
</style>